/**
 * 碰撞回店统计
 */
import { WORKORDERX3OVERVIEW } from '../types';

export default {
    name: `${WORKORDERX3OVERVIEW}`,
    path: '/workOrderX3Overview',
    component: () => import(/* webpackChunkName: 'workOrderX3Overview' */ '@/views/workOrderX3Overview/'),
    redirect: { name: `${WORKORDERX3OVERVIEW}Index` },
    meta: {
        title: '凯励程x3保养概况',
        savedPosition: { x: 0, y: 0 },
        noCache: true,
    },
    children: [
        {
            name: `${WORKORDERX3OVERVIEW}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'workOrderX3Overview' */ '@/views/workOrderX3Overview/home/Home.vue'),
        },
        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${WORKORDERX3OVERVIEW}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'workOrderX3Overview' */ '@/views/workOrderX3Overview/detail/detail.vue'),
        },
        {
            name: `${WORKORDERX3OVERVIEW}Detail2`,
            path: 'checkItem',
            component: () => import(/* webpackChunkName: 'workOrderX3Overview' */ '@/views/workOrderX3Overview/detail/checkItem.vue'),
            // meta: {
            //     title: '保养概况',
            //     savedPosition: { x: 0, y: 0 },
            //     noCache: true,
            // },
        },
    ],
};
